import type { TitledText } from '../types/content';

export const processSteps: TitledText[] = [
  {
    title: 'Discovery and Client Briefing',
    description: 'We begin with your strategy, culture, and leadership context to understand what the role must achieve and why it matters now.',
  },
  {
    title: 'Role Definition and Market Mapping',
    description: 'Together we define the leadership profile, then map relevant organizations, sectors, and talent pools.',
  },
  {
    title: 'Candidate Identification',
    description: 'Through structured research and direct outreach, we identify experienced leaders whose backgrounds align with the brief.',
  },
  {
    title: 'Candidate Evaluation and Engagement',
    description: 'We engage candidates discreetly, assessing experience, motivation, leadership style, and suitability in depth.',
  },
  {
    title: 'Shortlisting and Client Interviews',
    description: 'You receive a considered shortlist with clear rationale. We coordinate interviews and gather feedback on both sides.',
  },
  {
    title: 'Offer and Appointment Support',
    description: 'We support offer discussions, references, and the practicalities of transition so the appointment concludes well.',
  },
  {
    title: 'Post-Placement Follow-Up',
    description: 'We stay in contact with both the organization and the appointed leader through the early months of the role.',
  },
];

export const pillars: TitledText[] = [
  {
    title: 'Strategic Insight',
    description: 'Every search starts with your strategy and the outcomes your next leader must deliver — not just a job description.',
  },
  {
    title: 'Leadership Excellence',
    description: 'We look beyond titles to judgment, leadership style, and the experience that genuinely fits your organization.',
  },
  {
    title: 'Lasting Partnerships',
    description: 'We value relationships that extend beyond a single appointment, for clients and candidates alike.',
  },
];

export const commitments: TitledText[] = [
  {
    title: 'Relationship-driven search',
    description: 'We invest time in understanding the people involved — your stakeholders and the candidates we engage.',
  },
  {
    title: 'Strategic understanding',
    description: 'We define leadership requirements in relation to your strategy, structure, and long-term objectives.',
  },
  {
    title: 'Confidentiality-conscious engagement',
    description: 'Information about clients and candidates is shared carefully, with consent, and only as each stage requires.',
  },
  {
    title: 'Thoughtful assessment',
    description: 'We evaluate experience and suitability with care, giving you a clear rationale for every candidate we present.',
  },
  {
    title: 'Clear communication',
    description: 'You will know where the search stands, what we are learning from the market, and what comes next.',
  },
  {
    title: 'Long-term alignment',
    description: 'Our aim is an appointment that serves both the leader and the organization well beyond the first year.',
  },
];

export const values: TitledText[] = [
  { title: 'Integrity', description: 'We are honest with clients and candidates, including when the message is difficult.' },
  { title: 'Professionalism', description: 'We bring preparation, rigour, and courtesy to every interaction.' },
  { title: 'Discretion', description: 'We protect sensitive information and respect the trust placed in us.' },
  { title: 'Strategic Thinking', description: 'We connect every appointment to the organization’s wider direction.' },
  { title: 'Accountability', description: 'We take ownership of our commitments and follow through on them.' },
  { title: 'Long-Term Relationships', description: 'We measure our work by the relationships it builds over time.' },
];
